/** @format */

import React from 'react';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import PricelistSchemaElementInterface from '../../../../interfaces/billing/PricelistSchemaElementInterface';
import RateSchemaInterface from '../../../../interfaces/billing/RateSchemaInterface';
import { RateCall } from './RateCall';
import { RateService } from './RateService';
import { PriceThresholdContainer, PriceThresholdEntityInterface } from '../PriceThresholds/PriceThresholdContainer';
import CheckBoxSimple from '../../../../components/Form/CheckBoxSimple';

interface PricelistSchemaElementRateProps {
    entity: PricelistSchemaElementInterface;
    rateEntity: RateSchemaInterface;
    useRationCallback: (checked: boolean) => void;
    rateEntityStatus: any;
    changeRateInput: (e: any, stateName: string) => void;
    changeRateSelect: (e: any, stateName: string) => void;
    priceThresholds: Array<PriceThresholdEntityInterface>;
    setPriceThresholds: (thresholds: Array<PriceThresholdEntityInterface>) => void;
    priceThresholdsOpen: boolean;
}

export const PricelistSchemaElementRate = (props: PricelistSchemaElementRateProps): React.ReactElement => {
    return (
        <GridContainer>
            <GridItem xs={6}>
                <GridContainer spacing={0}>
                    <GridItem xs={12}>
                        {props.entity.type === 0 ? (
                            <RateCall
                                changeRateInput={props.changeRateInput}
                                changeRateSelect={props.changeRateSelect}
                                rateEntity={props.rateEntity}
                                rateEntityStatus={props.rateEntityStatus}
                            />
                        ) : (
                            <RateService
                                changeRateInput={props.changeRateInput}
                                rateEntity={props.rateEntity}
                                rateEntityStatus={props.rateEntityStatus}
                            />
                        )}
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={6}>
                <CheckBoxSimple checked={props.rateEntity.useRatio} label={'pricelists:h.count_proportionally'} callback={props.useRationCallback} />
                <PriceThresholdContainer
                    isOpen={props.priceThresholdsOpen}
                    setPriceThresholds={props.setPriceThresholds}
                    priceThresholds={props.priceThresholds}
                    rateEntity={props.rateEntity}
                    parentComponent={'pricelist'}
                />
            </GridItem>
        </GridContainer>
    );
};
